module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/chat-60b214625abeb4028f62ae3783ba18d6.svg";